import React from "react";
import { ROUTES } from "shared/constants/routes";
import {
  CheckoutTopBar,
  StepsNav,
  StepLink,
  StepSeparator,
} from "styles/pages/dtf-transfers/checkout";

const STEPS = [
  { id: "cart", label: "Cart", route: ROUTES.DTF_TRANSFERS_CART.LINK },
  { id: "information", label: "Information" },
  { id: "shipping", label: "Shipping" },
  { id: "payment", label: "Payment" },
];

const CheckoutSteps = ({ currentStep, onStepClick }) => {
  const currentIndex = STEPS.findIndex((step) => step.id === currentStep);

  return (
    <CheckoutTopBar>
      <StepsNav aria-label="Checkout progress">
        {STEPS.map((step, index) => {
          const isActive = step.id === currentStep;
          const isPast = index < currentIndex;
          const isClickable = isPast && step.id !== "cart";

          return (
            <React.Fragment key={step.id}>
              {index > 0 ? <StepSeparator>{">"}</StepSeparator> : null}
              <StepLink
                type="button"
                $active={isActive}
                $clickable={isClickable || Boolean(step.route)}
                onClick={() => {
                  if (step.route) {
                    onStepClick(step.route);
                    return;
                  }

                  if (isClickable) {
                    onStepClick(step.id);
                  }
                }}
              >
                {step.label}
              </StepLink>
            </React.Fragment>
          );
        })}
      </StepsNav>
    </CheckoutTopBar>
  );
};

export default CheckoutSteps;
